import React, { useMemo } from "react";
import { Team } from "../utils/types";
import useDuration from "../hooks/useDuration";
import { getDurationBetweenDates } from "../utils";
import { FALSE_ANSWER_TIME_EFFECT } from "../utils/constants";

export default function TeamScore({ team }: { team: Team }) {
  const duration = useMemo(() => {
    const updatedLastAnswerDate = new Date(team.lastAnswer_at);
    updatedLastAnswerDate.setSeconds(
      updatedLastAnswerDate.getSeconds() +
        FALSE_ANSWER_TIME_EFFECT * team.falseAnswers.length
    );
    return getDurationBetweenDates(
      team.create_at,
      updatedLastAnswerDate.toISOString()
    );
  }, [team.falseAnswers, team.lastAnswer_at]);
  return (
    <div className="team-score">
      <p className="team-name">{team.name}</p>
      <div className="team-data">
        <div className="titles">
          <p>Time</p>
          <p>Score</p>
        </div>
        <div className="values">
          <p>
            {!!duration?.minutes && <span> {duration?.minutes} M, </span>}
            <span> {duration?.seconds} sec</span>
          </p>
          <p>{team.score}</p>
        </div>
      </div>
    </div>
  );
}
